var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class List extends Component {
    constructor() {
        super('List', false);
        this.indexes = {};
        this.lastPosition = { x: 0, y: 0 };
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (window.matchMedia('(pointer:fine)').matches) {
                this.imageContaner = $.parseHTML('<div class="list-thumbnail-container position-fixed pe-none"></div>');
                $('body').append(this.imageContaner);
                $('.module-list p').on('mouseenter', (event, element) => {
                    this.mouseEnterHandler(event, element.find('a'));
                }).on('mousemove', (event) => {
                    this.mouseMoveHandler(event);
                }).on('mouseleave', () => {
                    this.imageContaner.empty();
                });
            }
            this.success();
        });
    }
    mouseEnterHandler(event, element) {
        this.imageContaner.empty();
        if (element.data('thumbnail') == '')
            return;
        this.imageContaner.append($.parseHTML('<img src="' + element.data('thumbnail') + '" alt="" class="w-100">')).removeClass('d-none');
    }
    mouseMoveHandler(event) {
        this.imageContaner.css({
            top: event.clientY + 15,
            left: event.clientX + 15
        });
    }
}
